export default __webpack_public_path__ + "static/media/arrow-back.12ae07da.svg";